import { render, staticRenderFns } from "./OptionEditImagesTab.vue?vue&type=template&id=90992e62"
import script from "./OptionEditImagesTab.vue?vue&type=script&lang=ts"
export * from "./OptionEditImagesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports